import { render } from "./GoogleTranslate.vue?vue&type=template&id=fefc3a12"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js"

import "./GoogleTranslate.vue?vue&type=style&index=0&id=fefc3a12&lang=css"
import "./GoogleTranslate.vue?vue&type=style&index=1&id=fefc3a12&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__